export var PageId;
(function (PageId) {
  PageId["ACTIVITY_SEARCH"] = "page.LX.Search,A,20";
  PageId["ACTIVITY_DETAIL"] = "page.LX.Infosite.Information,A,30";
  PageId["ACTIVITY_DETAIL_LANG"] = "ActivityDetails";
})(PageId || (PageId = {}));
export var getPageName = function (pageId) {
  return pageId.substring(0, pageId.indexOf(','));
};